import React from 'react';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import WeddingPhotoUploader from "./WeddingPhotoUploader";
import AdminDashboard from "./AdminDashboard";
import SuperAdmin from "./SuperAdmin";
import EventIndex from "./EventIndex";
import PricingPage from "./PricingPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<EventIndex />} />
        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/event/:eventId" element={<WeddingPhotoUploader />} />
        <Route path="/admin/:eventId" element={<AdminDashboard />} />
        <Route path="/super-admin" element={<SuperAdmin />} />
      </Routes>
    </Router>
  );
}

export default App;
